import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import IntlProvider from './IntlProvider';

type Props = {
    children: React.ReactNode;
    store: any;
};
const Provider = ({ children, store }: Props) => (
    <ReduxProvider store={store}>
        <IntlProvider locale="en">{children}</IntlProvider>
    </ReduxProvider>
);

export default Provider;
